import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as DocumentSvg } from "../../../assets/icons/doc-uploader-folder.svg";

import "../../../styles/documentUploader.scss";
import { formatFileSize } from "../../../helpers/common.helper";

// TODO: Add file size limits
const DocumentUploader = ({
  name,
  multiple,
  accept,
  onChange,
  defaultFiles,
  hideFiles,
}) => {
  const inputFileRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [files, setFiles] = useState(defaultFiles ?? []);

  const handleFiles = (_files) => {
    if (_files.length === 0) return;

    if (!multiple) {
      setFiles([_files[0]]);
      return;
    }

    Object.keys(_files).forEach((i) => {
      // * Check if file already exists
      const _file = _files[i];

      if (files.find((file) => file.name === _file.name)) {
        return;
      }

      setFiles((curr) => [...curr, _file]);
    });

    // * Clear input value
    inputFileRef.current.value = "";
  };

  useEffect(() => {
    onChange(files);
  }, [files]);

  const handleDragDropEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if ((e.type === "dragenter" || e.type === "dragover") && !dragActive) {
      setDragActive(true);
    }

    if ((e.type === "dragleave" || e.type === "drop") && dragActive) {
      setDragActive(false);
    }

    if (e.type === "drop") {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleDeleteClick = (index) => {
    setFiles((curr) => curr.filter((_, i) => index !== i));
  };

  return (
    <div className="doc-uploader">
      <div
        className={`doc-uploader__uploader ${
          dragActive ? "doc-uploader__uploader--highlight" : ""
        }`}
        onDragEnter={handleDragDropEvents}
        onDragOver={handleDragDropEvents}
        onDragLeave={handleDragDropEvents}
        onDrop={handleDragDropEvents}
      >
        <DocumentSvg />
        <div
          className="doc-uploader__uploader__text"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <span className="doc-uploader__uploader__text__line">
            Drop your document here, or{" "}
            <label
              className="doc-uploader__uploader__input-trigger"
              // onClick={handleLabelClick}
              htmlFor={name}
            >
              browse
            </label>
          </span>
          <span className="doc-uploader__uploader__text__line">
            Support: PDF, Jpeg, DWG
          </span>
          <input
            id={name}
            ref={inputFileRef}
            style={{ display: "none" }}
            multiple={multiple}
            type="file"
            accept={accept}
            onChange={(e) => handleFiles(e.target.files)}
          />
        </div>
      </div>
      {!hideFiles && files.length > 0 ? (
        <div className="doc-uploader__gallery">
          {files.map((f, index) => (
            <div className="doc-uploader__gallery__file">
              <div className="doc-uploader__gallery__file__name">{f.name}</div>
              <div className="doc-uploader__gallery__file__size">
                {formatFileSize(f.size)}
              </div>
              <div
                className="doc-uploader__gallery__file__delete"
                onClick={() => handleDeleteClick(index)}
              >
                Delete
              </div>
            </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

DocumentUploader.propTypes = {};

export default DocumentUploader;
